import React from 'react';
import { connect } from 'react-redux';

import BCLLoading from '../../common/Loading/BCLLoading';
import HomeAdvisor from './HomeAdvisor';

class HomeAdvisorContainer extends React.Component {
  render() {
    const { configs } = this.props;
    return (
      <>
        {configs && configs.data ? <HomeAdvisor configs={configs.data}/> : <BCLLoading />}
      </>
    );
  }
}


const mapStateToProps = state => {
  return {
      configs: state.configs
  }
}


export default connect(mapStateToProps, null)(HomeAdvisorContainer);